//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/TaggedObjectCollection.js";
import "../Assemblies/Assemblies.ComponentAssembly.js";
let d=[[],[[["subset"],"CreateSubsetBuilder",{R_:{builder:"Assemblies.SubsetBuilder"}},1,0],[["boxSearchTerm"],"CreateBoxSearchTermBuilder",{R_:{boxSearchTermBuilder:"Assemblies.BoxSearchTermBuilder"}},1,0],[["planeSearchTerm"],"CreatePlaneSearchTermBuilder",{R_:{planeSearchTermBuilder:"Assemblies.PlaneSearchTermBuilder"}},1,0],[["attributeSearchTerm"],"CreateAttributeSearchTermBuilder",{R_:{attributeSearchTermBuilder:"Assemblies.AttributeSearchTermBuilder"}},1,0],[["proximitySearchTerm"],"CreateProximitySearchTermBuilder",{R_:{proximitySearchTermBuilder:"Assemblies.ProximitySearchTermBuilder"}},1,0],[["runContentProximitySearchTerm"],"CreateRunContentProximitySearchTermBuilder",{R_:{runContentProximitySearchTermBuilder:"Assemblies.RunContentProximitySearchTermBuilder"}},1,0],[["positioningTask"],"CreatePositioningTaskBuilder",{R_:{builder:"Assemblies.PositioningTaskBuilder"}},1,0],[["subsetBuilderTag"],"CreateMechanicalRoutingSubsetBuilder",{R_:{builder:"Assemblies.MechanicalRoutingSubsetBuilder"}},1,0],[["subsetBuilderTag"],"CreateMechanicalRoutingSubsetBuilderForSurroundingEdit",{R_:{builder:"Assemblies.MechanicalRoutingSubsetBuilder"}},1,0]],[]];
SPLM.Assemblies.SubsetCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Assemblies.SubsetCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;